import { render, staticRenderFns } from "./OrderDisplayView.vue?vue&type=template&id=88e9f5d8"
import script from "./OrderDisplayView.vue?vue&type=script&lang=js"
export * from "./OrderDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports